import { useState } from 'react';


export default function CloseSave (
    {setClose, bold,
    c='white', 
    bc='black',
    hc='black',
    hbc='white',
    text='X',
    left=true,
    fs='20pt'}
    ) {

    const [hover, setHover] = useState(false);
    const style = {
        'color' : hover ? hc : c,
        'backgroundColor' : hover ? hbc : bc,
        'fontSize': fs,
        'position': 'absolute',
        'top': '0px',
        'cursor': 'pointer',
        'padding': '0px 10px',
        'borderRadius': '3px'
    }
    left ? style['left'] = '0px' : style['right'] = '0px';
    bold && (style['fontWeight'] = bold);

    return (
    <p
    onClick={setClose}
    onMouseEnter={() => setHover(true)}
    onMouseLeave={() => setHover(false)}
    style={style}
    >
        {text}
    </p>
    )
}